// extracted by mini-css-extract-plugin
export var boxItems = "_8l-1";
export var boxItemsLg = "_8l-2";
export var button = "_8l-7";
export var buttonHoverless = "_8l-9";
export var buttonLg = "_8l-8";
export var filterGroupBox = "_8l-0";
export var icon = "_8l-3";
export var iconSecondary = "_8l-6";
export var iconWrapper = "_8l-4";
export var iconWrapperLg = "_8l-5";
export var truncatedLabel = "_8l-a";